import { definePreset } from '@primeng/themes';
import { environment } from 'projects/cms/src/environments/environment';

export const AppTheme = definePreset(environment.theme.preset, {
  semantic: {
    primary: {
      50: `{${environment.theme.color}.50}`,
      100: `{${environment.theme.color}.100}`,
      200: `{${environment.theme.color}.200}`,
      300: `{${environment.theme.color}.300}`,
      400: `{${environment.theme.color}.400}`,
      500: `{${environment.theme.color}.500}`,
      600: `{${environment.theme.color}.600}`,
      700: `{${environment.theme.color}.700}`,
      800: `{${environment.theme.color}.800}`,
      900: `{${environment.theme.color}.900}`,
      950: `{${environment.theme.color}.950}`,
    },
    colorScheme: {
      light: {
        primary: {
          color: `{${environment.theme.color}.950}`,
          contrastColor: '#ffffff',
          hoverColor: `{${environment.theme.color}.900}`,
          activeColor: `{${environment.theme.color}.800}`,
        },
        highlight: {
          background: `{${environment.theme.color}.950}`,
          focusBackground: `{${environment.theme.color}.700}`,
          color: '#ffffff',
          focusColor: '#ffffff',
        },
        formField: {
          hoverBorderColor: '{primary.color}',
        },
      },
      dark: {
        primary: {
          color: `{${environment.theme.color}.50}`,
          contrastColor: `{${environment.theme.color}.950}`,
          hoverColor: `{${environment.theme.color}.100}`,
          activeColor: `{${environment.theme.color}.200}`,
        },
        highlight: {
          background: 'rgba(250, 250, 250, .16)',
          focusBackground: 'rgba(250, 250, 250, .24)',
          color: 'rgba(255,255,255,.87)',
          focusColor: 'rgba(255,255,255,.87)',
        },
        formField: {
          hoverBorderColor: '{primary.color}',
        },
      },
    },
    focusRing: {
      width: '2px',
      style: 'dashed',
      color: '{primary.color}',
      offset: '1px',
    },
  },
});
